import * as layoutStyles from './layout.styles'

export function propStyles(props={}, styles=layoutStyles) {
  return Object.keys(props).reduce((acc, curr) => {
    if (curr === "className") {
      acc.classes.push(props[curr])
    } else if (styles[curr]) {
      acc.classes.push(styles[curr])
    } else {
      acc.props[curr] = props[curr]
    }
    return acc
  }, {classes: [], props: {}})
}
